import {
  LOAD_CATEGORIES_ACTION, SET_EDITED_CATEGORY_ACTION, SAVE_EDITED_CATEGORY_ACTION,
  SELECT_CATEGORY_ACTION,
} from '../actions/categories-actions';
import {
  LOAD_NOTES_LIST_ACTION,
} from '../actions/notes-actions';
import { thriftPlugin } from '../thriftPlugin';

export default {
  state: {
    categoriesList: [],
    editedCategory: undefined,
    selectedCategory: undefined,
  },
  actions: {
    [LOAD_CATEGORIES_ACTION](ctx) {
      thriftPlugin.CategoriesService.getAllCategories()
        .then(
          (response) => {
            ctx.commit('setCategoriesList', response);
            ctx.dispatch(LOAD_CATEGORIES_ACTION);
          },
        );
    },
    [SELECT_CATEGORY_ACTION](ctx, categoryId) {
      ctx.commit('selectCategory', categoryId);
      ctx.dispatch(LOAD_NOTES_LIST_ACTION, ctx.state.selectedCategory);
    },
    [SAVE_EDITED_CATEGORY_ACTION](ctx, payload) {
      const updatedCategory = {
        categoryCaption: payload.caption,
      };
      thriftPlugin.CategoriesService.saveCategory(updatedCategory)
        .then(() => {
          ctx.commit('setEditedCategory', undefined);
          ctx.dispatch(LOAD_CATEGORIES_ACTION);
        });
    },
    [SET_EDITED_CATEGORY_ACTION](ctx, payload) {
      ctx.commit('setEditedCategory', payload);
    },
  },
  mutations: {
    setCategoriesList(state, catList) {
      state.categoriesList = catList;
    },
    setEditedCategory(state, category) {
      state.editedCategory = category;
    },
    selectCategory(state, categoryId) {
      if (state.selectedCategory === categoryId) {
        state.selectedCategory = undefined;
      } else {
        state.selectedCategory = categoryId;
      }
    },
  },
  getters: {
    categoriesList(state) {
      return state.categoriesList;
    },
    categoryForEdit(state) {
      return state.editedCategory;
    },
    selectedCategory(state) {
      return state.selectedCategory;
    },
  },
};
